import { TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import variables from "styles/base/_universal.scss";
import "styles/components/CustomTextField.scss";

const CustomTextField = ({
  label,
  rows = 4,
  rowsMax = 4,
  multiline,
  link,
  handleChange,
  normalinput,
  value = "",
  disabled = false,
  required = false,
  charLimit,
  isGenAiComObj,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const Component = link || normalinput ? UrlInput : Multiline;
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (!charLimit || newValue.length <= charLimit) {
      setInputValue(newValue);
      handleChange(newValue);
    }
  };

  return (
    <div
      className={`textfield-container ${isFocused ? "focused" : ""}`}
      style={{ marginBottom: "16px" }}
    >
      <Component
        id={`textfield`}
        label={label}
        variant="filled"
        fullWidth={true}
        rows={rows}
        rowsMax={rowsMax}
        multiline={multiline}
        onChange={handleInputChange}
        normalinput={normalinput}
        autoComplete="off"
        value={value}
        disabled={disabled}
        required={required}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        isGenAiComObj={isGenAiComObj}
      />
      {charLimit && (
        <div className="char-count">
          {inputValue.length}/{charLimit} chars
        </div>
      )}
    </div>
  );
};

const FilledTextField = styled(TextField).withConfig({
  shouldForwardProp: (prop) => prop !== "isGenAiComObj",
})(({ isGenAiComObj }) => ({
  "& .MuiFilledInput-root": {
    backgroundColor: "#fff",
    lineHeight: 1.5,
    fontSize: "12px",
    border: "1px solid #ccc",
    paddingRight: "0px",
    borderRadius: "6px",
    paddingBottom: "0px",
    height: isGenAiComObj ? "auto" : "158px", // for genai 95
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingTop: "4px",
    fontWeight: variables.fontWeight600,
  },
  "& .MuiFilledInput-multiline": {
    paddingTop: isGenAiComObj ? "15px" : "3px",
    paddingRight: "4px",
    whiteSpace: "normal",
    overflow: "hidden",
  },
  "& .MuiFilledInput-root:hover": {
    backgroundColor: "#fff",
  },
  "& .MuiFilledInput-input": {
    lineHeight: "1.5",
    transition: "none",
    paddingRight: "5px",
    fontWeight: 600,
    color: "#333",
    textOverflow: "ellipsis",
    whiteSpace: "wrap",
    // marginLeft: "-5px",
  },
  "& .MuiFilledInput-input.Mui-disabled": {
    marginLeft: "0.7px",
  },
  "& .MuiFilledInput-underline:focus": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:after": {
    borderBottom: "none",
  },
  "& .MuiFilledInput-underline:hover:before": {
    borderBottom: "none",
  },
  "& .MuiFormLabel-asterisk": {
    color: "#e32b35",
  },
}));

const Multiline = styled(FilledTextField)({
  "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
    transform: " translate(12px, 12px) scale(0.75) !important",
  },
  "& .MuiFormLabel-root": {
    marginTop: "-5px",
  },
});

const UrlInput = styled(FilledTextField)(({ normalinput }) => ({
  "& .MuiFilledInput-root": {
    height: "42px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "wrap",
  },
  "& .MuiFilledInput-input": {
    paddingTop: "10.5px",
    color: normalinput ? variables.searchTextColor : variables.themeColor,
    fontWeight: variables.fontWeight600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "wrap",
    paddingLeft: "12px",
  },
  "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
    transform: "translate(12px, 7px) scale(0.75) !important",
    fontSize: "12px !important",
  },
  "& .MuiInputBase-input": {
    height: "42px ",
  },
  "& .MuiInputLabel-filled": {
    transform: "translate(12px, 17px) scale(1)",
  },
}));

export default CustomTextField;
